// Industries data for LEION Engineering
import { Scale, Truck, Factory, HardHat, Wheat, Ship, Pickaxe, Warehouse } from 'lucide-react';

export const INDUSTRIES = [
  {
    id: 'mining',
    name: 'Mining & Quarries',
    icon: 'Pickaxe',
    description: 'Heavy-duty weighing solutions for mining operations, ensuring accurate payload measurement and regulatory compliance.',
    challenges: [
      'Extreme operating conditions',
      'High volume throughput requirements',
      'Dust and debris exposure',
      'Remote location operations',
    ],
    solutions: [
      'Pitless weighbridges with extended platforms',
      'Weigh-in-motion systems for continuous operation',
      'Rugged indicators with IP65+ protection',
      'Remote monitoring and data transmission',
    ],
    products: ['pitless-weighbridge', 'weigh-in-motion', 'mega-hitech-combi'],
    stats: {
      installations: '50+',
      capacity: 'Up to 120T',
      accuracy: '±0.05%',
    },
  },
  {
    id: 'logistics',
    name: 'Logistics & Transportation',
    icon: 'Truck',
    description: 'Streamline your supply chain with precise weighing at every checkpoint. Prevent overloading and optimize fleet efficiency.',
    challenges: [
      'High vehicle throughput',
      'Quick turnaround times',
      'Regulatory compliance',
      'Integration with TMS systems',
    ],
    solutions: [
      'Pit-type weighbridges for seamless flow',
      'Weigh-in-motion for non-stop weighing',
      'Automated ticketing systems',
      'ERP/TMS integration',
    ],
    products: ['pit-type-weighbridge', 'weigh-in-motion', 'hitech-combi-indicator'],
    stats: {
      installations: '100+',
      throughput: '500+ vehicles/day',
      integration: 'SAP/Oracle ready',
    },
  },
  {
    id: 'manufacturing',
    name: 'Manufacturing',
    icon: 'Factory',
    description: 'Precision weighing for raw material receipt, process control, and finished goods dispatch.',
    challenges: [
      'Inventory accuracy',
      'Process control integration',
      'Quality assurance',
      'Space constraints',
    ],
    solutions: [
      'Platform scales for incoming materials',
      'In-line weighing integration',
      'Batch weighing systems',
      'Custom capacity solutions',
    ],
    products: ['industrial-platform-scale', 'hitech-combi-indicator', 'boss-series-table-top'],
    stats: {
      installations: '200+',
      accuracy: 'Class III OIML',
      integration: 'PLC compatible',
    },
  },
  {
    id: 'construction',
    name: 'Construction',
    icon: 'HardHat',
    description: 'Mobile and permanent weighing solutions for construction sites. Track material movement and prevent overloading.',
    challenges: [
      'Temporary site requirements',
      'Rough terrain',
      'Material tracking',
      'Equipment mobility',
    ],
    solutions: [
      'Portable truck weighing pads',
      'Mobile pitless weighbridges',
      'Rugged wireless indicators',
      'Quick-deploy solutions',
    ],
    products: ['pitless-weighbridge', 'industrial-platform-scale'],
    stats: {
      deployment: '24-48 hours',
      mobility: 'Fully relocatable',
      durability: 'All-terrain',
    },
  },
  {
    id: 'agriculture',
    name: 'Agriculture',
    icon: 'Wheat',
    description: 'Weighing solutions for farms, grain elevators, and agricultural processing. Accurate measurement from field to market.',
    challenges: [
      'Seasonal peak loads',
      'Outdoor exposure',
      'Variable load sizes',
      'Rural connectivity',
    ],
    solutions: [
      'All-weather weighbridges',
      'Grain hopper scales',
      'Livestock weighing systems',
      'Mobile weighing units',
    ],
    products: ['pitless-weighbridge', 'industrial-platform-scale', 'boss-series-table-top'],
    stats: {
      installations: '150+',
      weather: 'All-season operation',
      connectivity: 'GSM/GPRS ready',
    },
  },
  {
    id: 'ports',
    name: 'Ports & Shipping',
    icon: 'Ship',
    description: 'High-capacity weighing for maritime logistics. Ensure compliance with SOLAS VGM requirements.',
    challenges: [
      'SOLAS VGM compliance',
      'High capacity requirements',
      'Corrosive environment',
      '24/7 operations',
    ],
    solutions: [
      'VGM-certified weighbridges',
      'Stainless steel load cells',
      'Container weighing systems',
      'Multi-platform installations',
    ],
    products: ['pit-type-weighbridge', 'mega-hitech-combi'],
    stats: {
      capacity: 'Up to 150T',
      compliance: 'SOLAS VGM certified',
      operation: '24/7/365',
    },
  },
];

export const getIndustryById = (id) => {
  return INDUSTRIES.find(industry => industry.id === id);
};
